import React from 'react';
import './HeroSection.css'; // Import the component-specific styles
import { useNavigate } from 'react-router-dom';

function HeroSection() {
  const navigate = useNavigate();

  const handleBookArchana = () => {
    navigate('/services');
  };

  return (
    // Converted HTML to JSX (class -> className)
    <section className="hero-section hero-bg">
      <div className="hero-inner">
        <h1 className="hero-title">Experience Divine Blessings from Sacred Temples</h1>
        <p className="hero-subtitle">Iswaran connects you with authentic Hindu religious services. Receive blessings and divine grace from the comfort of your home.</p>
        <div className="hero-buttons">
          <button className="btn btn-primary btn-xl hero-btn" onClick={handleBookArchana}>Book Archana Now</button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
